import { DefaultValue } from "../../components/dataEntry/inputs/Dropdown/models/DefaultValue";

const DEFAULT_VALUES_DROPDOWN: DefaultValue = {
    valueInput: "",
    valueText: "Оберіть зі списку",
}

export { DEFAULT_VALUES_DROPDOWN };